import { Component, OnInit, ViewChild } from '@angular/core';
import {
  GridComponent,
  ToolbarItems,
  SearchSettingsModel,
  QueryCellInfoEventArgs,
  FilterService,
  SortService,
  ToolbarService,
  FilterSettingsModel,
  IFilter,
} from '@syncfusion/ej2-angular-grids';
import { WizardService } from '../services/wizard.service';
import {
  SelectedJobs,
  ActivePhase,
  Employee,
  FilterActivePhaseViewModel,
  AuditHistoryViewModel,
} from '../models/wizard.model';
import { isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import {
  JobSchedulePhaseViewModel,
  JobScheduleViewModel,
} from '../models/JobScheduleViewModel';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { NgxSpinnerService } from 'ngx-spinner';
import { ItemModel, MenuEventArgs } from '@syncfusion/ej2-angular-splitbuttons';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-job-detail',
  templateUrl: './job-detail.component.html',
  styleUrls: ['./job-detail.component.scss'],
  providers: [
    FilterService,
    SortService,
    ToolbarService,
    FilterActivePhaseViewModel,
    SelectedJobs,
    ActivePhase,
    JobSchedulePhaseViewModel,
  ],
})
export class JobDetailComponent implements OnInit {
  showHistoryGrid: boolean = false;
  showHistory: boolean = false;
  gridDataSource: any;
  @ViewChild('historyGrid')
  public historyGrid!: GridComponent;
  public filterOptions!: FilterSettingsModel;
  public filter!: IFilter;

  constructor(
    private wizardService: WizardService,
    public activePhase: ActivePhase,
    public selectedJobs: SelectedJobs,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private userService: UserService
  ) {
    this.activePhase = new ActivePhase();
    this.selectedJobs.ActivePhase = new Array<ActivePhase>();
    this.JobScheduleViewModel = new JobScheduleViewModel();
    this.JobScheduleViewModel.jobSchedulePhaseViewModelList =
      new Array<JobSchedulePhaseViewModel>();
  }

  public items: ItemModel[] = [
    {
      text: 'Inspector Call Made',
      iconCss: 'fa fa-phone-square',
    },
    {
      text: 'Inspector Call Needed',
      iconCss: 'fa fa-phone',
    },
    {
      text: 'Unmark Inspector Call Made',
      iconCss: 'fa fa-phone-square',
    },
    {
      text: 'Unmark Inspector Call Needed',
      iconCss: 'fa fa-phone',
    },
    {
      text: 'Mark as Rained Out',
      iconCss: 'fa fa-tint',
    },
    {
      text: 'Unmark as Rained Out',
      iconCss: 'fa fa-tint',
    },
    {
      text: 'Copy Job',
      iconCss: 'fa fa-copy',
    },
    {
      text: 'Cancel Job',
      iconCss: 'fa fa-ban',
    },
    {
      text: 'Uncancel Job',
      iconCss: 'fa fa-undo',
    },
    {
      text: 'Delete Job',
      iconCss: 'fa fa-trash',
    },
    {
      text: 'History',
      iconCss: 'fa fa-history',
    },
  ];

  JobScheduleViewModel: JobScheduleViewModel;
  jobScheduleId: any;
  currentJobScheduleId: any;
  isScheduler: any;
  isGeneralUser: any;
  hasEmployeeData!: false;
  selectedEmployeeData: any;
  step1 = true;
  public allowEditForDate = false;
  pageSettings!: { pageSizes: boolean; pageSize: number };
  @ViewChild('grid')
  public grid!: GridComponent;
  @ViewChild('addEmployeeGrid')
  public addEmployeeGrid!: GridComponent;
  @ViewChild('selectedPhaseGrid')
  public selectedPhaseGrid!: GridComponent;
  public toolbar!: ToolbarItems[];
  public searchSettings!: SearchSettingsModel;
  sortOptions!: { columns: { field: string; direction: string }[] };

  ngOnInit(): void {
    this.currentJobScheduleId = this.route.snapshot.params['Id'];
    if (!isNOU(this.currentJobScheduleId)) {
      this.spinner.show();
      this.GetJobScheduleDataByScheduleId(this.currentJobScheduleId);
    }
    this.CheckIfUserIsScheduler();

    this.filterOptions = {
      type: 'Menu',
    };
    this.filter = {
      type: 'CheckBox',
    };
  }

  GetJobScheduleDataByScheduleId(jobScheduleId: any): any {
    return this.wizardService
      .GetJobScheduleDataByJobScheduleId(jobScheduleId)
      .subscribe(
        (res: { body: JobScheduleViewModel }) => {
          if (res.body != null) {
            setTimeout(() => {
              this.JobScheduleViewModel = res.body;

              this.selectedJobs.ActivePhase = new Array<ActivePhase>();

              this.selectedJobs.startDate = this.JobScheduleViewModel.startDate;
              this.selectedJobs.companyId = this.JobScheduleViewModel.companyId;
              for (const iterator of this.JobScheduleViewModel
                .jobSchedulePhaseViewModelList) {
                const tempActivePhase = new ActivePhase();
                tempActivePhase.description = iterator.phaseDescription;
                tempActivePhase.jobId = this.JobScheduleViewModel.contractId;
                tempActivePhase.estHours = null;
                tempActivePhase.estLaborProd = iterator.estLaborProd;
                tempActivePhase.estLaborUnits = null;
                tempActivePhase.isActive = !iterator.isDeleted;
                tempActivePhase.isDeleted = iterator.isDeleted;
                tempActivePhase.item = null;
                tempActivePhase.phaseGroupId = null;
                tempActivePhase.phaseId = iterator.phaseId;
                tempActivePhase.employees = iterator.employees;
                tempActivePhase.employeesFullName = iterator.employeesFullName;
                tempActivePhase.um = null;
                // tempActivePhase.expProd = iterator.expProd;
                tempActivePhase.isAdded = true;
                tempActivePhase.workForce = new Array<Employee>();
                tempActivePhase.workForce = iterator.employeeViewModelList;

                this.selectedJobs.ActivePhase.push(tempActivePhase);
              }

              this.spinner.hide();
            }, 2000);
          } else {
            // console.log(res);
          }
        },
        (error: any) => {
          // console.log('Error: ', error);
        }
      );
  }

  Close(): void {
    this.router.navigate(['/Scheduler']);
  }

  tooltip(args: QueryCellInfoEventArgs): any {
    const tooltip: Tooltip = new Tooltip(
      {
        content: (args as any).data[(args.column as any).field] as string,
      },
      args.cell as HTMLTableCellElement
    );
  }

  CheckIfUserIsScheduler() {
    this.userService.IsScheduler().subscribe(
      (responsesData: any) => {
        this.isScheduler = true;
      },
      (error: any) => {
        this.isScheduler = false;
      }
    );
  }

  CheckIfUserIsGeneralUser() {
    this.userService.IsGeneralUser().subscribe(
      (responsesData: any) => {
        this.isGeneralUser = true;
      },
      (error: any) => {
        this.isGeneralUser = false;
      }
    );
  }
  CancelJob() {
    this.wizardService.CancelJob(this.currentJobScheduleId).subscribe(
      (responsesData: any) => {
        this.JobScheduleViewModel.previousJobScheduleStatusId =
          this.JobScheduleViewModel.jobScheduleStatusId;
        this.JobScheduleViewModel.previousJobScheduleStatusName =
          this.JobScheduleViewModel.jobScheduleStatusName;
        this.JobScheduleViewModel.jobScheduleStatusName = 'Cancelled';
        this.JobScheduleViewModel.jobScheduleStatusId = 4;
        const message = 'This job was cancelled successfully';
        Swal.fire('Job Schedule', message, 'success');
      },
      (error: any) => {
        const message = 'Something went wrong';
        Swal.fire('Job Schedule', message, 'success');
      }
    );
  }
  UnCancelJob() {
    this.wizardService.UnCancelJob(this.currentJobScheduleId).subscribe(
      (responsesData: any) => {
        this.JobScheduleViewModel.jobScheduleStatusName =
          this.JobScheduleViewModel.previousJobScheduleStatusName;
        this.JobScheduleViewModel.jobScheduleStatusId =
          this.JobScheduleViewModel.previousJobScheduleStatusName;
        const message = 'This job was cancelled successfully';
        Swal.fire('Job Schedule', message, 'success');
      },
      (error: any) => {
        const message = 'Something went wrong';
        Swal.fire('Job Schedule', message, 'success');
      }
    );
  }

  MarkAsRainedOut() {
    this.wizardService
      .MarkAsRainedOut(
        this.currentJobScheduleId,
        this.JobScheduleViewModel.rainedOut
      )
      .subscribe(
        (responsesData: any) => {
          this.JobScheduleViewModel.rainedOut =
            !this.JobScheduleViewModel.rainedOut;
          const message = 'Updated successfully';
          Swal.fire('Job Schedule', message, 'success');
        },
        (error: any) => {
          const message = 'Something went wrong';
          Swal.fire('Job Schedule', message, 'success');
        }
      );
  }

  CopyJobSchedule() {
    this.wizardService.CopyJobSchedule(this.currentJobScheduleId).subscribe(
      (responsesData: string) => {
        // localStorage.setItem('dataSource', JSON.stringify(this.JobScheduleViewModel)); // setting
        this.router.navigateByUrl('/Wizard/' + responsesData);
      },
      (error: any) => {
        const message = 'Something went wrong';
        Swal.fire('Job Schedule', message, 'success');
      }
    );
  }

  DeleteJob() {
    this.wizardService
      .DeleteJobSchedule(this.JobScheduleViewModel.jobScheduleId)
      .subscribe(
        (responsesData: any) => {
          const message = 'Job was deleted successfully';
          Swal.fire('Job Schedule', message, 'success');
          this.router.navigate(['/Scheduler']);
        },
        (error: any) => {
          const message = 'Something went wrong';
          Swal.fire('Job Schedule', message, 'success');
        }
      );
  }
  InspectorCalled() {
    this.wizardService
      .InspectorCalled(this.JobScheduleViewModel.jobScheduleId)
      .subscribe(
        (responsesData: any) => {
          this.JobScheduleViewModel.inspectorCalled =
            !this.JobScheduleViewModel.inspectorCalled;
          const message = 'Updated successfully';
          Swal.fire('Job Schedule', message, 'success');
        },
        (error: any) => {
          const message = 'Something went wrong';
          Swal.fire('Job Schedule', message, 'success');
        }
      );
  }
  InspectorNeeded() {
    this.wizardService
      .InspectorNeeded(this.JobScheduleViewModel.jobScheduleId)
      .subscribe(
        (responsesData: any) => {
          this.JobScheduleViewModel.inspectorNeeded =
            !this.JobScheduleViewModel.inspectorNeeded;
          const message = 'Updated successfully';
          Swal.fire('Job Schedule', message, 'success');
        },
        (error: any) => {
          const message = 'Something went wrong';
          Swal.fire('Job Schedule', message, 'success');
        }
      );
  }

  public select(args: MenuEventArgs) {
    if (
      args.item.text === 'Inspector Call Made' ||
      args.item.text === 'Unmark Inspector Call Made'
    ) {
      this.InspectorCalled();
    } else if (
      args.item.text === 'Inspector Call Needed' ||
      args.item.text === 'Unmark Inspector Call Needed'
    ) {
      this.InspectorNeeded();
    } else if (args.item.text === 'Mark as Rained Out') {
      this.MarkAsRainedOut();
    } else if (args.item.text === 'Unmark as Rained Out') {
      this.MarkAsRainedOut();
    } else if (args.item.text === 'Copy Job') {
      this.CopyJobSchedule();
    } else if (args.item.text === 'Cancel Job') {
      const message = 'Are you sure you want to cancel the job?';
      Swal.fire({
        title: 'Job Action',
        text: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          this.CancelJob();
        }
      });
    } else if (args.item.text === 'Uncancel Job') {
      this.UnCancelJob();
    } else if (args.item.text === 'Delete Job') {
      const message = 'Are you sure you want to delete the job?';
      Swal.fire({
        title: 'Job Action',
        text: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          this.DeleteJob();
        }
      });
    } else if (args.item.text === 'History') {
      const jobscheduleId = this.route.snapshot.params['Id'];
      this.toolbar = ['Search'];
      this.pageSettings = { pageSizes: true, pageSize: 10 };

      this.showHistory = true;
      this.GetAuditHistory(jobscheduleId);
    }
  }

  public addDisabled(args: MenuEventArgs) {
    if (
      args.item.text === 'Inspector Call Made' &&
      this.JobScheduleViewModel.inspectorCalled
    ) {
      args.element.classList.add('e-visible');
    }
    if (
      args.item.text === 'Inspector Call Needed' &&
      this.JobScheduleViewModel.inspectorNeeded
    ) {
      args.element.classList.add('e-visible');
    }
    if (
      args.item.text === 'Unmark Inspector Call Made' &&
      !this.JobScheduleViewModel.inspectorCalled
    ) {
      args.element.classList.add('e-visible');
    }
    if (
      args.item.text === 'Unmark Inspector Call Needed' &&
      !this.JobScheduleViewModel.inspectorNeeded
    ) {
      args.element.classList.add('e-visible');
    }
    if (
      args.item.text === 'Mark as Rained Out' &&
      this.JobScheduleViewModel.rainedOut
    ) {
      args.element.classList.add('e-visible');
    }
    if (
      args.item.text === 'Unmark as Rained Out' &&
      !this.JobScheduleViewModel.rainedOut
    ) {
      args.element.classList.add('e-visible');
    }
    if (
      args.item.text === 'Uncancel Job' &&
      this.JobScheduleViewModel.jobScheduleStatusName != 'Cancelled'
    ) {
      args.element.classList.add('e-visible');
    }
    if (
      args.item.text === 'Cancel Job' &&
      this.JobScheduleViewModel.jobScheduleStatusName === 'Cancelled'
    ) {
      args.element.classList.add('e-visible');
    }
  }

  GetAuditHistory(jobscheduleId: any) {
    return this.wizardService
      .GetAuditHistoryByJobScheduleId(jobscheduleId)
      .subscribe(
        (result: { body: AuditHistoryViewModel }) => {
          this.gridDataSource = result.body;
        },
        (error: any) => {}
      );
  }

  GoBack(): any {
    this.showHistory = false;
  }
}
